
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/reset",
      function () {
        return require("private-next-pages/app/reset.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/reset"])
      });
    }
  